"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var events = {
    accountModal: {
        open: 'ACCOUNT_MODAL_OPEN',
        close: 'ACCOUNT_MODAL_CLOSE',
        userLoggedIn: 'ACCOUNT_MODAL_LOGIN_COMPLETE',
        userLoggedOut: 'ACCOUNT_MODAL_LOGOUT_COMPLETE',
        userError: 'ACCOUNT_MODAL_USER_ERROR',
    },
    supportDropDown: {
        open: 'SDD_OPEN',
        close: 'SDD_CLOSE',
    },
};
exports.default = events;
